import classnames from 'classnames';
import { Button } from '@material-ui/core';
import * as React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import { NavLink } from 'react-router-dom';

import styles from './welcome.less';

export const Welcome: React.SFC<RouteComponentProps<void>> = (props) => (
    <React.Fragment>
        {}
        <Redirect to="/login" />
        {}

        {}
    </React.Fragment>
);
